import _ from 'lodash'
import { Header, TableColumn, TableRow } from './Table.types'

export const getRows = (data: any[], columns: TableColumn[]): TableRow[] | [] => {
  if (_.isEmpty(data)) return []
  const result: TableRow[] = []
  data.forEach((row, index) => {
    const resultRow: TableRow = {
      key: index.toString(),
      cells: []
    }
    columns.forEach((column) => {
      const { align, key } = column
      resultRow.cells.push({
        align: align ?? 'flex-start',
        columnKey: key,
        value: column.customComponent ? column.customComponent(row) : row[key],
        gridColumns: column.gridColumns,
        hide: column.hide
      })
    })
    result.push(resultRow)
  })
  return result
}

export const getHeader = (columns: TableColumn[]): Header | null => {
  if (!columns) {
    return null
  }
  const resultHeader: Header = {
    cells: []
  }
  columns.forEach((column) => {
    const { align, key } = column
    resultHeader.cells.push({
      columnKey: key,
      value: column.name,
      disableSort: column.disableSort,
      gridColumns: column.gridColumns,
      hide: column.hide,
      align: align ?? 'flex-start'
    })
  })
  return resultHeader
}
